<script setup>
import { computed } from 'vue';
import { capitalize } from 'lodash';
import { useRoute } from 'vue-router';
import CoverView from '@/views/shared/CoverView.vue';
import TTS from '@/components/shared/Tts.vue';
import { getStartDay } from '@/utils/helpers';
import i18n from '@/utils/i18n';
import TitleBlock from '@/components/shared/blocks/TitleBlock.vue';
import PictogramsBlock from '@/components/shared/blocks/PictogramsBlock.vue';
import DescriptionBlock from '@/components/shared/blocks/DescriptionBlock.vue';
import { useNewsStore } from '@/stores/news';
import MediaBlock from '@/components/shared/blocks/MediaBlock.vue';
import InstitutionBlock from '@/components/shared/blocks/InstitutionBlock.vue';
import BlocksWrapper from '@/components/shared/blocks/BlocksWrapper.vue';
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';

const newsStore = useNewsStore();
const route = useRoute();

const moduleColor = computed(() => {
  return route?.meta?.color;
});

const newsEntry = computed(() => {
  return newsStore.all.find((newsEntry) => newsEntry.id === route.params.id);
});

const published = computed(() => {
  return `${i18n.global.t('news.published')} ${getStartDate(newsEntry.value.startDate)}`;
});

function getStartDate(dateString) {
  const startDay = getStartDay(dateString, true);
  return startDay.includes('.')
    ? capitalize(i18n.global.t(startDay))
    : capitalize(startDay);
}
</script>

<template>
  <div class="newsEntry">
    <CoverView
      v-if="newsEntry"
      :image-url="newsEntry.coverImage.source"
      :module-color="moduleColor"
    >
      <div class="newsEntryContent tts-content">
        <div class="flex items-start justify-between">
          <TitleBlock margin="pt-20" :text="newsEntry.title" />
          <TTS />
        </div>

        <MediaBlock
          :pictures="newsEntry.pictures"
          :videos="newsEntry.videos"
          :documents="newsEntry.documents"
          :color="moduleColor"
        />

        <BlocksWrapper>
          <InstitutionBlock
            :title="newsEntry.institution.name"
            :image="newsEntry.institution.logo.source"
          />

          <BasicBlock
            :icon="['fal', 'calendar']"
            :text="published"
            :aria-description="published"
          />

          <PictogramsBlock
            v-if="newsEntry.pictograms.length"
            :pictograms="newsEntry.pictograms"
          />

          <DescriptionBlock :description="newsEntry.body" />
        </BlocksWrapper>
      </div>
    </CoverView>
  </div>
</template>
